import { getNamesByNodes } from '../../actions/form';
import { Dispatch } from 'redux';
import { ControlInterface } from 'edocatbase/Form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from '../../../TextField';

interface NodeRefInterface extends ControlInterface, ReduxComponentInterface {
	formInstanceId: string;
	innerFormInstanceId?: string;
	readOnly: boolean;
}

class NodeRef extends window.React.PureComponent<NodeRefInterface> {
	componentDidMount() {
		const { actions, name, value, formInstanceId, innerFormInstanceId } = this.props;
		if (value)
			actions.getNamesByNodes(
				formInstanceId,
				name,
				value?.value ? value.value.split(',') : value.split(','),
				innerFormInstanceId
			);
	}

	onChange = (event: Event) => {
		event.preventDefault();
	};

	render() {
		const { label, name, value, placeholder, readOnly, helperText, important, disabled } = this.props;

		return (
			<div className={`form-row row-${name}`}>
				<TextField
					id={name}
					label={label}
					name={name}
					onChange={this.onChange}
					type="text"
					value={value?.label || (readOnly ? window.Alfresco.messages.global['label.none'] : '')}
					placeholder={placeholder}
					readOnly={readOnly}
					helperText={helperText}
					important={important}
					disabled={disabled}
				/>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ getNamesByNodes }, dispatch),
});

export default connect(null, mapDispatchToProps)(NodeRef);
